// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeInviteGetBody = {
  inviteId: string;
};

export type typeInviteGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    inviteId: string;
    poolId: string;
    poolName: string;
    invitedByName: string;
    sportLabel: string;
    contestLabel: string;
    sentAtLabel: string;
    status:
      | "pending"
      | "approvalPending"
      | "accepted"
      | "declined"
      | "revoked"
      | "expired";
    memberCount: number;
    rulesSummary: string;
    bannerImageUrl?: string | null;
    creatorHandle?: string | null;
  };
};

export type typeInviteGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInviteGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInviteGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaInviteGetBody = {
  type: "object",
  properties: { inviteId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["inviteId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createInviteGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaInviteGetBody);
  }

  return async function postInviteGet(
    payload: typeInviteGetBody,
  ): Promise<typeInviteGetOutput200 | typeInviteGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postInviteGet" failed before calling the network. #41db084b61a1`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#41db084b61a1" },
        },
        data: null,
      } as typeInviteGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/invite/get`,
      httpMethod: "POST",
      options,
    })) as typeInviteGetOutput200 | typeInviteGetOutput400;
  };
}
